<template>
    <div id="contenedor-main-listado-anticipos">
        <template
            v-if="!$vuetify.breakpoint.xs">
            <desktop :listadoResponsables="listadoResponsables"></desktop>
        </template>
        <template
            v-else>
            <mobile :listadoResponsables="listadoResponsables"></mobile>
        </template>
    </div>
</template>

<script>
import Desktop from './Desktop.vue';
import Mobile from './Mobile.vue';

export default {
  name: 'MainListadoAnticipos',
  props: {
    listadoResponsables: {
      type: Array,
      required: true,
    },
  },
  components: {
    Desktop,
    Mobile,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
